<template>
    <Card >
      <AjaxForm route="admin/rejectOfferReason/add">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput placeholder="عنوان..."
                         label="عنوان"
                         type="text"
                         name="title"></CustomInput>
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput type="select" label="نوع" v-model="typeUser" select-label="title" :select-options="options"
                         name="type" placeholder="نوع کاربر را انتخاب کنید" reduce_select="value" />
          </div>
          <div class="col-12 col-sm-12 col-md-4">
            <CustomInput placeholder="توضیحات..."
                         label="توضیحات"
                         type="textarea"
                         name="description"></CustomInput>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-10 col-sm-8 col-md-5 mx-auto">
            <button type="submit" class="btn btn-info btn-block">ثبت اطلاعات</button>
          </div>
        </div>
      </AjaxForm>
    </Card>
</template>

<script>
import MasterLayout from "@/components/MasterLayout";
import Card from "@/components/forms/Card";
import AjaxForm from "@/components/forms/AjaxForm";
import CustomInput from "@/components/CustomInput";
import vSelect from 'vue-select'
import {mapActions} from "vuex";
export default {
  name: "rejectOfferReasonAdd",
  components: {CustomInput, AjaxForm, Card, MasterLayout,vSelect},
  data()
  {
    return{
      typeUser : null,
      options : [
          {value : 'seller',title : 'فروشنده'},
          {value : 'buyer',title : 'خریدار'},
          ]
    }
  },
  async mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('افزودن دلیل رد کردن پیشنهاد');
    this.setShowHead(true);
  },
  methods: {
    ...mapActions('app', {
      setPageTitle: 'setPageTitle',
      setPageLoading: 'setPageLoading',
      setShowHead: 'setShowHead'
    }),
  }
}
</script>

<style scoped>

</style>